export default "﻿<div class=\"toast\">\r\n    <p data-bind=\"text: viewModel.message\"></p>\r\n</div>"